import axios from "axios";

const instance = axios.create({
    baseURL: process.env.REACT_APP_CALENDAR_URL,
    headers: {
        "Content-Type": "application/json",
    },
});

const responseBody: any = (response: any) => response.data;

const request = {
    get: (url: string) => instance.get(url).then().then(responseBody),
    post: (url: string, body?: any) => instance.post(url, body).then().then(responseBody),
};

const Calendar = {
    GetCountry: () => request.get("/countries"),
    GetCity: (city: string) => request.get("/find-location?name=" + city),
    GetCityByCountry: (country: string) => request.get("/find-location?country=" + country),
    GetCalendar: (params: any) => request.post("/calendar", params),
};

export async function GetCountryAsync() {
    return await Calendar.GetCountry()
        .then((response) => {
            return {response};
        })
        .catch((error) => {
            return error.response;
        });
}

export async function GetCityAsync(city: string) {
    return await Calendar.GetCity(city)
        .then((response) => {
            return {response};
        })
        .catch((error) => {
            return error.response;
        });
}

export async function GetCityByCountryAsync(country: string) {
    return await Calendar.GetCityByCountry(country)
        .then((response) => {
            return {response};
        })
        .catch((error) => {
            return error.response;
        });
}

export async function GetCalendarAsync(params: any) {
    return await Calendar.GetCalendar(params)
        .then((response) => {
            return {response};
        })
        .catch((error) => {
            return error.response;
        });
}
